import axios from 'axios';
import type { AxiosResponse } from 'axios';
import type { HandshakeRequest, HandshakeResponse, PublicKeyResponse, WebResult } from '@/types/crypto';
import { ENDPOINT_HANDSHAKE, ENDPOINT_PUBLIC_KEY } from '@/utils/constants/encryption';

const { VITE_API_BASE_URL } = import.meta.env;

/**
 * 明文 axios 实例，用于握手阶段（尚未建立会话密钥）
 */
const plainClient = axios.create({
    baseURL: VITE_API_BASE_URL,
    timeout: 30000,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

export type ApiResponse<T> = Promise<WebResult<T>>;

/**
 * 获取服务端 ECDH 公钥
 */
export function getPublicKey(): ApiResponse<PublicKeyResponse> {
    return plainClient
        .get<WebResult<PublicKeyResponse>>(ENDPOINT_PUBLIC_KEY)
        .then((res: AxiosResponse<WebResult<PublicKeyResponse>>) => res.data);
}

/**
 * 握手，提交客户端临时公钥
 */
export function handshake(data: HandshakeRequest): ApiResponse<HandshakeResponse> {
    return plainClient
        .post<WebResult<HandshakeResponse>>(ENDPOINT_HANDSHAKE, data)
        .then((res: AxiosResponse<WebResult<HandshakeResponse>>) => res.data);
}
